import { Tag, Typography } from "antd";
import styled from "styled-components";

export const SignatureContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: end;
  img {
    width: 30%;
  }
`;

export const SignatureBox = styled.div`
  border: 1px solid #d9d9d9;
  width: 100%;
  border-radius: 5px;
  height: 101px;
  overflow: hidden;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

export const SwitchLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

export const InfoText = styled(Typography)`
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 10px;
`;

export const EmailTemplateColorBox = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
`;

export const VariableTag = styled(Tag)`
  margin-right: 0;
  margin-bottom: 4px;
`;

const ResizableContainer = styled.div`
  position: relative;
  resize: vertical;
  overflow: hidden;
  min-height: 200px;
  max-height: 800px;
  /* margin-bottom: 40px; */
  /* border: 1px solid #d9d9d9; */
  /* border-radius: 4px; */
  display: flex;
  flex-direction: column;

  .quill {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;

    .ql-toolbar {
      flex: 0 0 auto;
    }

    .ql-container {
      flex: 1;
      overflow: auto;
      height: auto;

      .ql-editor {
        min-height: 150px;
        height: 100%;

        p {
          margin: 0 0 4px 0;
        }
      }
    }
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    cursor: se-resize;
    background: #f0f0f0;
  }
`;
export const EmailPreviewContainer = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 1rem;

  p {
    margin: 0 0 4px 0;
  }
`;


export const EmailItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .emailName {
    width: 100%;

    span{
      width: 100%;

      @media (max-width: 425px) {
        max-width: calc(100% - 38px);
      }
    }
  }
`;